<div class="container-fluid">
  <div *ngIf="!loading" class="row graficas">
    <div class="col-md-12 col-xs-12 col-lg-12">
      <div class="cardDispositivos card-body withoutPadding">
        <app-device-last-stats-list
          [title]="title"
          [allDevicesWithChildren]="devicesWithChildren"
          [parentDeviceId]="tab.currentDeviceDetail.uuid"
          [deviceChildrenList]="tab?.currentDeviceDetail?.children"
          (deviceItemNavegate)="navigate($event)"
          [loadingChildren]="loading"
          [selectedLanguage]="selectedLanguage"
        >
        </app-device-last-stats-list>
      </div>
    </div>
  </div>
  <app-loading *ngIf="loading" [loadingText]="loadingText"></app-loading>
</div>
